import clsx from 'clsx';
import { Controller, useFormContext } from 'react-hook-form';

import ErrorMessage from '@/components/atoms/ErrorMessage';
import InputLabel from '@/components/atoms/InputLabel';
import { Label } from '@/components/atoms/Typography/Label';

import styles from './FormFieldWrapper.module.css';

import type { FormFieldWrapperProps } from './FormFieldWrapper.types';
import type { FieldValues } from 'react-hook-form';

function FormFieldWrapper<T extends FieldValues>({
  children,
  inline,
  label,
  labelVariant,
  name,
  rules,
  helperText,
}: FormFieldWrapperProps<T>) {
  const { control } = useFormContext<T>();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <div className={clsx(styles.formFieldWrapper, inline ? styles.inline : '')}>
          {label && (
            <InputLabel htmlFor={name} isRequired={rules?.required} variant={labelVariant}>
              {label}
            </InputLabel>
          )}
          {helperText && (
            <Label size="sm" variant="secondary">
              {helperText}
            </Label>
          )}
          {children({ ...field }, fieldState)}
          {fieldState.error && <ErrorMessage>{fieldState.error.message}</ErrorMessage>}
        </div>
      )}
    />
  );
}

FormFieldWrapper.displayName = 'FormFieldWrapper';
export default FormFieldWrapper;
